import { render, staticRenderFns } from "./ExpertsDetail.vue?vue&type=template&id=25892186&scoped=true&"
import script from "./ExpertsDetail.vue?vue&type=script&lang=js&"
export * from "./ExpertsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExpertsDetail.vue?vue&type=style&index=0&id=25892186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25892186",
  null
  
)

export default component.exports